import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";
import { useIntl } from "react-intl";

type AddNewOptionInputProps = {
  label: string;
  required?: boolean;
  maxLength?: number;
  error?: boolean;
  helperText?: string;
  onAdd: (value: string) => void;
  onCancel: () => void;
};

const AddNewOptionInput = ({
  label,
  required = false,
  maxLength,
  error = false,
  helperText,
  onAdd,
  onCancel,
}: Readonly<AddNewOptionInputProps>) => {
  const { formatMessage: t } = useIntl();
  const [newOption, setNewOption] = useState("");

  const add = () => {
    const trimmed = newOption.trim();

    if (!trimmed) {
      return;
    }

    onAdd(trimmed);
    setNewOption("");
  };

  return (
    <TextField
      variant="standard"
      fullWidth
      autoFocus
      required={required}
      label={label}
      value={newOption}
      onChange={(event) => setNewOption(event.target.value)}
      error={error}
      helperText={helperText}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          add();
        } else if (event.key === "Escape") {
          onCancel();
        }
      }}
      inputProps={{ maxLength }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={add}
              edge="end"
              color="primary"
              aria-label={t({ id: "creatableSelectConfirmNewOption" })}
            >
              <CheckIcon />
            </IconButton>
            <IconButton
              onClick={onCancel}
              edge="end"
              color="error"
              aria-label={t({ id: "creatableSelectCancelNewOption" })}
            >
              <CloseIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default AddNewOptionInput;
